<template>
    <div id="app">
        <div id="nav">
            <router-link v-if="authenticated" :to="{ name: 'adminPage'}" v-on:click.native="logout()" replace>Logout
            </router-link>
            <router-view/>
            <app-login></app-login>
        </div>
    </div>
</template>

<script>
    import loginPage from "./loginPage";
    export default {
        name: 'adminPage',
        components: {
            'app-login': loginPage,
        },
        data() {
            return {
                authenticated: false,
                mockAccount: [
                    {username: "ano"},
                    {password: "ano"}
                ],
            }
        },
        mounted() {
            if (!this.authenticated) {
                this.$router.replace({name: "adminPage"});
            }
        },
        methods: {
            setAuthenticated(status) {
                this.authenticated = status;
            },
            logout() {
                this.authenticated = false;
            }
        }
    }
</script>

<style scoped>
    body {
        background-color: #F0F0F0;
    }

    h1 {
        padding: 0;
        margin-top: 0;
    }

    #app {
        width: 1024px;
        margin: auto;
    }
</style>